import {
    SECTION_TEMPLATE_DETAILS_SUCCESS,
    SECTION_TEMPLATE_DETAILS_FAILURE,
    SECTION_TEMPLATE_FILE_DOWNLOAD_SUCCESS,
    SECTION_TEMPLATE_FILE_DOWNLOAD_FAILURE
} from './action';

const initialState = {
    sectionTemplateDetails: null,
    sectionTemplateDetailsError: null,
    sectionTemplateDownloadUrl: null,
    sectionTemplateDownloadUrlError: null
}

const sectionTemplateViewReducer = (state = initialState, action) => {
    switch (action.type) {
        case SECTION_TEMPLATE_DETAILS_SUCCESS:
            return state = {
                ...state,
                sectionTemplateDetails: action.data
            }
        case SECTION_TEMPLATE_DETAILS_FAILURE:
            return state = {
                ...state,
                sectionTemplateDetailsError: action.data
            }
        case SECTION_TEMPLATE_FILE_DOWNLOAD_SUCCESS:
            return state = {
                ...state,
                sectionTemplateDownloadUrl: action.data
            }
        case SECTION_TEMPLATE_FILE_DOWNLOAD_FAILURE:
            return state = {
                ...state,
                sectionTemplateDownloadUrlError: action.data
            }
        default: return state
    }
}
export default sectionTemplateViewReducer;